import { useEffect, useState } from 'react';
import {
  InboxIcon,
  PersonIcon,
  StarOutline,
  Vivier,
} from '../../../../assets/icons';
import SidebarUnitDesktop from '../../components/SidebarUnitDesktop';

const VivierTaleez = () => {
  const [vivierExpanded, setVivierExpanded] = useState(
    localStorage.getItem('vivier-expanded') === 'true'
  );

  useEffect(() => {
    localStorage.setItem('vivier-expanded', vivierExpanded);
  }, [vivierExpanded]);

  return (
    <>
      <SidebarUnitDesktop 
        routeName={'Viviers'} 
        routeSidebar={null}
        icon={Vivier}
        text="Viviers"
        activePatterns={['/vivier', '/listAllVivier', '/ficheVivier', '/vivier-rating-temp-worker']}
        expandOnly={true}
        onExpandClick={() => setVivierExpanded(!vivierExpanded)}
      />
      {vivierExpanded && (
        <>
          <SidebarUnitDesktop
            routeName={'Candidats'}
            routeSidebar={'/vivier'}
            icon={PersonIcon}
            iconColor="#374151"
            text="Candidats"
            isSubItem={true}
            exactMatch={true}
          />
          <SidebarUnitDesktop
            routeName={'Tous les viviers'}
            routeSidebar={'/listAllVivier'}
            icon={InboxIcon}
            iconColor="#374151"
            text="Tous les viviers"
            isSubItem={true}
          />
          <SidebarUnitDesktop
            routeName={'Avis'}
            routeSidebar={'/vivier-rating-temp-worker/rating-untreated'}
            icon={StarOutline}
            iconColor="#374151"
            text="Avis"
            isSubItem={true}
          />
        </>
      )}
    </>
  );
};

export default VivierTaleez;
